var map = {
	"./ADA.svg": 812,
	"./BCH.svg": 813,
	"./BNB.svg": 814,
	"./BTC.svg": 815,
	"./CHZ.svg": 816,
	"./DASH.svg": 817,
	"./DOGE.svg": 818,
	"./DOT.svg": 819,
	"./ETC.svg": 820,
	"./ETH.svg": 821,
	"./EUR.svg": 822,
	"./GBP.svg": 823,
	"./LINK.svg": 824,
	"./LTC.svg": 825,
	"./MATIC.svg": 826,
	"./MKR.svg": 827,
	"./SHIB.svg": 828,
	"./SOL.svg": 829,
	"./TRX.svg": 830,
	"./UNI.svg": 831,
	"./USD.svg": 832,
	"./USDT.svg": 833,
	"./XLM.svg": 834,
	"./XMR.svg": 835,
	"./XRP.svg": 836,
	"./documents.svg": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;